import React from 'react';

import fetch from './../fetch';



/**
 * 题型处理（获取量表依据，并划分维度）
 * @method multiple
 * @param {object} [targetId]
 * @return {promise}
 */
 const questionsHandle = (targetId) => {

    const defaultsParams = {
		targetId: targetId
    };
    return fetch.post('eval/questionnaireAnalysis/questionsHandle', defaultsParams)
}

 const getEvalAnalysisData = (keywords) => {
    const session = JSON.parse(sessionStorage.session || '{"account": {}}')
    const account = session.account;

    const defaultsParams = {
        bgTermId: account.termId,
        endTermId: account.termId
    };
    return fetch.post('eval/questionnaireAnalysis/getEvalAnalysisData', Object.assign(defaultsParams, keywords))
}

/**
 * 问卷分析数据导出
 * @method multiple
 * @param {object} [keywords]
 * @return {promise}
 */
 const exportAnalysisData = (keywords) => {
    const session = JSON.parse(sessionStorage.session || '{"account": {}}')
    const account = session.account;

    const defaultsParams = {
        bgTermId: account.termId,
        endTermId: account.termId
    };
    return fetch.download('eval/questionnaireAnalysis/exportAnalysisDataBatch', Object.assign(defaultsParams, keywords), "问卷分析数据.xls")
}

/**
 * 信度分析
 * @param {object} [keywords]
 * @return {promise}
 */
 const reliabilityAnalysis = (keywords) => {
    const session = JSON.parse(sessionStorage.session || '{"account": {}}')
    const account = session.account;

    const defaultsParams = {
        bgTermId: account.termId,
        endTermId: account.termId
    };
    return fetch.post('eval/questionnaireAnalysis/reliabilityAnalysis', Object.assign(defaultsParams, keywords))
}

/**
 * 效度分析
 * @param {object} [keywords]
 * @return {promise}
 */
 const validityAnalysis = (keywords) => {
    const session = JSON.parse(sessionStorage.session || '{"account": {}}')
    const account = session.account;

    const defaultsParams = {
        bgTermId: account.termId,
        endTermId: account.termId
    };
    return fetch.post('eval/questionnaireAnalysis/validityAnalysis', Object.assign(defaultsParams, keywords))
}

export default {
    exportAnalysisData,
	questionsHandle,
    reliabilityAnalysis,
    validityAnalysis,
    getEvalAnalysisData
}